import React, { useCallback, useState } from 'react'
import classNames from 'classnames'
import Path from '@leverege/path'
import { Button, Dialog, Dialogs, Flex, TextInput } from '@leverege/ui-elements'
import SimAttributeView from './SimAttributeView'

import S from './style.css'

const CLEAR = {}

export default function MapAttributeView( props ) {
  const { onSetValue, node : attr, device, deviceData, controller, cxt = {} } = props
  const path = attr.path.substring( 0, attr.path.length - 1 )
  const [ newKey, setNewKey ] = useState( null )
  const [ newValue, setNewValue ] = useState( null )

  const v = Path.get( path, deviceData )
  const onChange = useCallback( ( e ) => {
    if ( e.data === CLEAR ) {
      const onClose = Dialogs.show( {
        component : Dialog.Question,
        props : {
          title : 'Delete All Keys',
          okay : 'Delete All',
          message : `Are you sure you want to delete ALL keys at "${path}"?`,
          onOkay : ( e ) => {    
            onSetValue( { attribute : attr, cxt, path, value : null } )
            onClose()
          }, 
          onCancel : () => { onClose() }
        }
      } )
    } else {

      const onClose = Dialogs.show( {
        component : Dialog.Question,
        props : {
          title : 'Delete Key',
          okay : 'Delete',
          message : `Are you sure you want to delete the key "${e.data}"?`,
          onOkay : () => {    
            onSetValue( { attribute : attr, cxt, path : `${path}/${e.data}`, value : e.value } )
            onClose()
          },
          onCancel : () => { onClose() }

        }
      } )
    }
  }, [ attr, cxt, path, onSetValue ] )

  const rtn = []
  if ( v != null ) {
    const keys = Object.keys( v )
    for ( let i = 0; i < keys.length; i++ ) {
      rtn.push( (
        <Flex direction="row" key={`${keys[i]}-hdr`}>
          {/* <Button 
            variant="link"
            icon="fa fa-times fa-fw" 
            eventData={keys[i]}
            onClick={onChange} /> */}
          <span className={S.attrLabel}>{keys[i]}</span> 
        </Flex>
      ) )
      rtn.push( (
        <SimAttributeView
          key={`${keys[i]}-view`}
          cxt={cxt}
          simulated={false}
          device={device}
          updaters={controller.state.updaters} 
          attribute={attr}
          name={null}
          eventData={keys[i]}
          value={v[keys[i]]} 
          onSetValue={onChange}/> 
      ) )
      rtn.push( (
        <div className={S.flexRight} key={`${keys[i]}-path`}>
          <div className={S.attrViewPath}>{path}/{keys[i]}</div> 
          <Button 
            variant="link"
            icon="fa fa-times fa-fw" 
            eventData={keys[i]}
            onClick={onChange} />
        </div>  
      ) )
      
    }
  }
  let name = attr.name
  if ( name[name.length - 1] === '@' ) {
    name = name.slice( 0, -1 )
  }

  const newKeyChange = useCallback( ( e ) => {
    const v = e.value?.trim()
    if ( newValue != null && v.length > 0 ) {
      onSetValue( { attribute : attr, cxt, path : `${path}/${v}`, value : newValue } )
      setNewKey( () => null )
      setNewValue( () => null )
    } else {
      setNewKey( v.length === 0 ? null : v )
    }
  }, [ attr, cxt, newValue, onSetValue, path ] )

  const onNewValueChange = useCallback( ( e ) => { 
    let v = e.value
    if ( typeof v === 'number' && Number.isNaN( v ) ) {
      v = null
    }
    if ( newKey != null && v != null ) {
      onSetValue( { attribute : attr, cxt, path : `${path}/${newKey}`, value : v } )
      setNewValue( () => null )
      setNewKey( () => null )
    } else {
      setNewValue( v )
    }
  }, [ attr, cxt, newKey, onSetValue, path ] )

  return (
    <div className={S.grpAttrSpanView}>
      <div className={S.attrViewHeader}>
        <div className={S.attrViewLabel}>
          <span className={S.attrLabel}>{name}</span>
          <span className={S.attrArrow}>&rarr;</span><span className={S.attrArrow}>&#123;</span>
        </div>
        <div className={S.flexRight}>
          <div className={S.attrViewPath}>{path}</div>
          <Button 
            variant="link"
            icon="fa fa-times fa-fw" 
            disabled={rtn.length === 0}
            eventData={CLEAR}
            onClick={onChange} />
        </div>  
      </div>
      <div className={classNames( S.grpAttrView, S.grpAttrNested )} >
        {rtn}
        <TextInput 
          variant="attrKey"
          hint="Add Key..." 
          acceptKey={validateKey}
          value={newKey} 
          onChange={newKeyChange} />
        <SimAttributeView
          cxt={cxt}
          simulated={false}
          device={device}
          updaters={controller.state.updaters} 
          attribute={attr}
          name={null} 
          value={newValue} 
          onSetValue={onNewValueChange} />
      </div>
      
      <div className={S.attrViewLabel}><span className={S.attrArrow}>&#125;</span></div>

    </div>
  )
}

const RX = /^[a-zA-Z0-9_]+$/
function validateKey( e ) {
  return RX.test( e.key )
}
